var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "card-modal",
    {
      attrs: { visible: _vm.isModelActive, title: "Detail Info" },
      on: {
        ok: _vm.hanldeClose,
        close: _vm.hanldeClose,
        cancel: _vm.hanldeClose,
      },
    },
    [
      _c("section", { staticClass: "modal-card-body" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Direction")]),
          _c("span", [
            _vm._v(
              _vm._s(_vm.entities.messageDirection == 1 ? "Sent" : "Recevied")
            ),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Request Json")]),
          _c("div", [_vm._v(_vm._s(_vm.entities.jsonDataRequest))]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Response Json")]),
          _c("div", [_vm._v(_vm._s(_vm.entities.jsonDataResponse))]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Sent On")]),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.$filters.formatDateTimeLocale(
                  _vm.entities.createdDate,
                  _vm.$userInfo.locale
                )
              )
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }